/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLocationTimeZonesRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetLocationTimeZonesResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getLocationTimeZones = (request: GetLocationTimeZonesRequest, options?: CashRequestOptions) => post<GetLocationTimeZonesRequest, GetLocationTimeZonesResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetLocationTimeZones", request, {...options, rejectOnError: true })